var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { assertEx, delay } from '@xyo-network/sdk-xyo-js';
import Fbq from './Fbq';
class BaseEvent {
    constructor(name) {
        this.name = name;
        this.fbq = assertEx(Fbq.instance, 'Missing Fbq');
    }
    send(_data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield delay(0); //force async to increase reporting odds
        });
    }
}
export default BaseEvent;
//# sourceMappingURL=BaseEvent.js.map